import { useEffect } from 'react'
import { useCart } from './useCart'
import { useAuth } from './useAuth'
import { evictSoldOrRedirect } from '@/lib/ecommerce/availability'

/* Drop into any checkout step page so the buyer cannot proceed
   while a sold item still sits in their cart. On mount the helper
   queries /api/cart/check-availability for every product UUID in
   the cart, removes the affected cart_items, stashes a toast
   payload in sessionStorage, and redirects to /cart where the
   eviction toast is rendered.

   The /cart page calls evictSoldOrRedirect directly with stay:true
   so this hook is intentionally limited to the redirecting case. */
export function useAvailabilityGuard(): void {
  const { items } = useCart()
  const { contactUuid } = useAuth()

  useEffect(() => {
    if (!items.length) return
    let cancelled = false
    evictSoldOrRedirect({ items, contactUuid })
      .catch(() => { /* submit-time gate covers the worst case */ })
      .finally(() => { /* cancellation is best-effort; redirect navigates anyway */ })
    return () => { cancelled = true }
    // intentionally omitted: redirect is a side effect we only want once per items snapshot
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [items.map((i) => i.product_uuid).join(','), contactUuid])
}
